import React from "react";
import { Form } from "react-bootstrap";

/**
 * Shared multi-line text field.
 * rows / row:            visible lines (row kept for existing callers)
 * onChange / onChangeHandler: change handler (onChangeHandler matches Input/Select)
 * error:                 shows the field as invalid with this message
 * Any other prop (maxLength, readOnly, autoFocus, disabled, aria-*, ...) is passed to the <textarea>.
 */
const Textarea = ({
  label,
  name,
  id,
  value = "",
  placeholder = "",
  required = false,
  row = 3,
  rows,
  onChange,
  onChangeHandler,
  className = "",
  error,
  type, // not a textarea attribute; accepted so callers passing it don't leak it to the DOM
  ...rest
}) => {
  const fieldId = id ? id : name;

  return (
    <Form.Group>
      {label && (
        <Form.Label htmlFor={fieldId}>
          {label}
          {required && <i className="text-danger ms-1">*</i>}
        </Form.Label>
      )}
      <textarea
        name={name}
        id={fieldId}
        className={`form-control cursor-pointer ${error ? "is-invalid" : ""} ${className}`.trim()}
        value={value}
        placeholder={placeholder}
        onChange={onChange || onChangeHandler}
        required={required}
        rows={rows ?? row}
        aria-invalid={Boolean(error) || undefined}
        {...rest}
      />
      {error && <div className="invalid-feedback d-block mt-1">{error}</div>}
    </Form.Group>
  );
};

export default Textarea;
